import api from '../helpers/api'

export const getDataStreamConfigs = () => api.get(`/configs/datastream`)
export const saveDataStreamConfig = (config: any) => api.post(`/configs/datastream`, config)
export const deleteDataStreamConfig = (id: number) => api.delete(`/configs/datastream/${id}`)
